export const essentialsUsers = {
  default: 25,
  max: 50,
};

export const essentialsEnv = {
  default: 1,
  max: 2,
};

export const concurrentUsers = {
  min: 0,
  max: 500,
  default: 5,
};

export const authorizedUsers = {
  min: 0,
  max: 1500,
  default: 5,
};

export const healthScores = {
  min: 0,
  max: 1000000,
  default: 1000,
};

export const essentialsAppPoints = {
  maintenanceBaseAppPoint: 150,
  additionalUserAppPoint: 50,
  additionalEnvAppPoint: 48,
  inspectionBaseAppPoint: 175,
};

export const estMaintenanceTableData = {
  workOrdersHour: '100',
  healthScoresrHour: '1,000',
};

export const estInspectionTableData = {
  clientDevice: '5',
  inferencesHour: '10,000',
  storage: '500 GB',
};

export const standardAppPoints = {
  default: 245,
  concurrentUsers: 10,
  authorizedUsers: 3,
  healthScores: 1000,
  minPoint: 303,
};

export const Tiles = {
  tile1: 'essentials',
  tile2: 'standard',
  tile3: 'premium',
};

export const Package = {
  pkg1: 'Essentials',
  pkg2: 'Standard',
  pkg3: 'Premium',
};

export const switchBrand = {
  brand1: 'Maintenance Essentials',
  brand2: 'Inspection Essentials',
};
